<template>
	<div v-if="user == null">
		<fullscreen-loading-indicator></fullscreen-loading-indicator>
	</div>
	<div class="dashboard-page" v-else>
		<!-- <template v-if="true"> -->
		<nav-bar name="Pagina Principal"></nav-bar>

		<template v-if="user.typeUser === UserType.Patient">
			<dashboard-patient></dashboard-patient>	
		</template>
		<template v-else-if="user.typeUser === UserType.Doctor">
			<dashboard-doctor></dashboard-doctor>
		</template>
	</div>
</template>

<script lang="ts">
	import NavBar from "@/components/NavBar.vue";
	import { defineComponent, onMounted } from "vue";
	import DashboardDoctor from "@/components/DashboardDoctor.vue";
	import DashboardPatient from "@/components/DashboardPatient.vue";
	import useUser from "@/store/UserState";
	import { UserType } from "@/domain/entities/UserTypes";
	import FullscreenLoadingIndicator from "@/components/FullscreenLoadingIndicator.vue";

	export default defineComponent({
		name: "Dashboard",

		components: {
			NavBar,
			DashboardPatient, DashboardDoctor, FullscreenLoadingIndicator
		},

		setup() {
			// const authState = useAuth();
			const { user, fetchUserData } = useUser();

			onMounted(async () => {
				await fetchUserData()
			});

			return {
				user,
				UserType,
			};
		},
	});
</script>

<style lang="stylus" scoped>

</style>
